/* eslint-disable */
Storage.prototype.setObject = function(key, value) {
    this.setItem(key, JSON.stringify(value));
};

Storage.prototype.getObject = function(key) {
    var value = this.getItem(key);
    return value && JSON.parse(value);
};

import Vue from 'vue';
Vue.config.debug = false;
Vue.config.productionTip = true;

import {startDragAndDropForElement} from './js/ESDDrag.js';
import './css/index.css';

import App from './App.vue';
import Utils from './js/utils';
import { checkUID } from './js/checkUID.js';
import { CHECKUID_FORCE_LOWERCASE } from "./js/constants.js";

window.startDragAndDropForElement = startDragAndDropForElement;

Vue.filter('capitalize', function(value) {
    if(!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('kb', val => {
    return Math.floor(val / 1024);
});

Vue.filter('removeSpecials', val => {
    return checkUID(val, CHECKUID_FORCE_LOWERCASE);
});

/** try:
oma, ,, opa, o p A, OpA
=> should result in 'oma,opa'
*/
Vue.filter('tagify', function(value) {
    if(!value) return '';
    const arr = value.toLowerCase().split(',').filter(e => e.length).map(s => s.trim().replace(/[^a-z0-9]/gi, '')); //make lowercase , filter empty values and trim
    const tagSet = new Set(arr);  // remove duplicates
    return Array.from(tagSet).join(','); // convert array to comma separated string
});


Vue.directive('esddrop', {
    bind: function(el, binding, vnode) {
        if(false) {
            console.log("esdrop-bind:", el, binding, vnode, "binding value-type:", typeof binding.value);
            const s = (x) => console.log(`binding-${x}`, binding[x]);
            s('name');
            s('value');
            s('expression');
            s('arg');
            s('modifiers');
        }
        if(typeof binding.value == 'object') {
            el.fn = binding.value.fn;
            el.args = binding.value.args;
        } else {
            el.fn = binding.value;
        }
    },
    // update: function(el, binding, vnode) {
    //     console.log("element was updated: ", el, binding, vnode)
    // },
    // When the bound element is inserted into the DOM...
    inserted: function(el) {
        //   console.log("esdrop-bind was inserted", el);

        const dragCallback = (evt, msg) => {
            var items = evt.dataTransfer.items;
            var files = evt.dataTransfer.files;
            if(items || files) {
                console.log('dragCallback:', msg, el, files, items);
            }
        };

        const interceptDragHilite = (evt, msg) => {
            return app.dragging;
        };

        startDragAndDropForElement(el, (evt) => {
            let internalDrag = false;
            var items = evt.dataTransfer.items;
            const dt = evt.dataTransfer;
            if(!internalDrag && el.fn && typeof el.fn == 'function') {
                el.fn(evt, el.args);
            }
        }, interceptDragHilite
        );
    }
});

Vue.mixin({
    created: function() { // don't use arrow-fn, to get the components 'this'
        const tagDef = this.$options._componentTag || location.pathname.split("/").pop() || "root";
        const tagClr = Utils && Utils.colorFromString ? Utils.colorFromString(tagDef) : 'ccee00';
        const tag = `%c[${tagDef}]`;
        let css = `color:#${tagClr};`;
        let warncss = `font-size: 1.2em; background-color: red; color:white;`;

        if(!this.debug) {
            this.debug = false;
        }

        if(this.hasOwnProperty('debugOptions')) {
            css = Object.entries(this.debugOptions).map(d => `${d[0]}:${d[1]}`).join(";");
        }
        // this.debug = false;
        this.dbg = this.debug ? console.log.bind(window.console, tag, css) : () => {};
        this.warn = this.debug ? console.warn.bind(window.console, tag, css) : () => {};
        this.error = this.debug ? console.warn.bind(window.console, tag, warncss) : () => {};
        this.__assert = console.assert.bind(window.console, false, tag, `color:#ffee00`);
        this.assert = this.debug ? (...parms) => {
            // if(!parms.shift()) this.__assert(...parms);
            if(!parms.shift()) this.warn(...parms);
        } : () => {};
    },
    // methods: {
    //     hello: function(msg) {
    //         console.log("MIXIN::", msg || 'hello from mixin!', document.querySelectorAll(".esd-dropzone"));
    //     },
    // }
});

const vm = new Vue({
    render: h => h(App),
}).$mount('#app');

window.vm = vm;